import styled from 'styled-components';

export const DivImage = styled.div`
    width:260px;
    height:260px;
    margin:20px;
    -webkit-box-shadow: 16px 17px 20px 12px rgba(212,212,212,1);
    -moz-box-shadow: 16px 17px 20px 12px rgba(212,212,212,1);
    box-shadow: 16px 17px 20px 12px rgba(212,212,212,1);

`

export const Image = styled.img`
    width:100%;
    border-radius:5px;
    transition:0.5s;
    cursor: pointer;
    :hover{
        transform:scale(1.112);
        transition:0.5s;

    }



`
export const DivBusca = styled.div`
    display:flex;
    flex-direction:row;
    width:100vw;
    flex-wrap:wrap;
    @media(max-width:800px){
        justify-content:center;
    }

`
